const tourdata= [
  {
    "id": 1,
    "city": "Delhi",
    "price": 141,
    "description": "Premium guided travel experience.",
    "ratings": 4.7,
    "hours": 7,
    "image": "https://www.bing.com/th/id/OIP.TJaq2V9n1PE9jANoMpnplgHaEv?w=226&h=211&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2",
    "type": "Religious",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 2,
    "city": "Mumbai",
    "price": 186,
    "description": "Premium guided travel experience.",
    "ratings": 4.1,
    "hours": 7,
    "image": "https://th.bing.com/th/id/OIP.iWuybF3U_U21pDpbScg4dgHaE8?w=249&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "adventure",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 3,
    "city": "Jaipur",
    "price": 82,
    "description": "Premium guided travel experience.",
    "ratings": 4.8,
    "hours": 4,
    "image": "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=400&h=300&q=80",
    "type": "wildlife",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 4,
    "city": "Goa",
    "price": 174,
    "description": "Premium guided travel experience.",
    "ratings": 4.8,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.NtWZ07CQhvq5Tr6UrKwigwHaEk?w=252&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "scenic",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 5,
    "city": "Varanasi",
    "price": 103,
    "description": "Premium guided travel experience.",
    "ratings": 4.9,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.Hdq8A05fSZxRDlRwO5oJywHaE8?w=308&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "historical",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 6,
    "city": "Agra",
    "price": 210,
    "description": "Premium guided travel experience.",
    "ratings": 4.5,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.QEjjFGjCo6H2znK-5POM9QHaE8?w=272&h=181&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "architecture",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 7,
    "city": "Udaipur",
    "price": 106,
    "description": "Premium guided travel experience.",
    "ratings": 4.9,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.ShQQnbhYvmU3g9jv5WwwoQHaE8?w=263&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "ghost",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 8,
    "city": "Kolkata",
    "price": 130,
    "description": "Premium guided travel experience.",
    "ratings": 4.1,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.prUkRnrQnCPc-bs4a10hWQHaEJ?w=282&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "food",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 9,
    "city": "Chennai",
    "price": 179,
    "description": "Premium guided travel experience.",
    "ratings": 4.3,
    "hours": 4,
    "image": "https://www.bing.com/th/id/OIP.TJaq2V9n1PE9jANoMpnplgHaEv?w=226&h=211&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2",
    "type": "Religious",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 10,
    "city": "Hyderabad",
    "price": 219,
    "description": "Premium guided travel experience.",
    "ratings": 4.6,
    "hours": 7,
    "image": "https://th.bing.com/th/id/OIP.iWuybF3U_U21pDpbScg4dgHaE8?w=249&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "adventure",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 11,
    "city": "Bangalore",
    "price": 227,
    "description": "Premium guided travel experience.",
    "ratings": 4,
    "hours": 5,
    "image": "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=600&q=80",
    "type": "wildlife",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 12,
    "city": "Shimla",
    "price": 95,
    "description": "Premium guided travel experience.",
    "ratings": 4.4,
    "hours": 6,
    "image": "https://th.bing.com/th/id/OIP.NtWZ07CQhvq5Tr6UrKwigwHaEk?w=252&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "scenic",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 13,
    "city": "Manali",
    "price": 103,
    "description": "Premium guided travel experience.",
    "ratings": 4.3,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.Hdq8A05fSZxRDlRwO5oJywHaE8?w=308&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "historical",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 14,
    "city": "Rishikesh",
    "price": 126,
    "description": "Premium guided travel experience.",
    "ratings": 4.7,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.QEjjFGjCo6H2znK-5POM9QHaE8?w=272&h=181&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "architecture",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 15,
    "city": "Amritsar",
    "price": 87,
    "description": "Premium guided travel experience.",
    "ratings": 4.6,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.ShQQnbhYvmU3g9jv5WwwoQHaE8?w=263&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "ghost",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 16,
    "city": "Mysore",
    "price": 190,
    "description": "Premium guided travel experience.",
    "ratings": 4,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.prUkRnrQnCPc-bs4a10hWQHaEJ?w=282&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "food",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 17,
    "city": "Darjeeling",
    "price": 186,
    "description": "Premium guided travel experience.",
    "ratings": 4.9,
    "hours": 4,
    "image": "https://www.bing.com/th/id/OIP.TJaq2V9n1PE9jANoMpnplgHaEv?w=226&h=211&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2",
    "type": "Religious",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 18,
    "city": "Leh",
    "price": 101,
    "description": "Premium guided travel experience.",
    "ratings": 4.6,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.iWuybF3U_U21pDpbScg4dgHaE8?w=249&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "adventure",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 19,
    "city": "Pune",
    "price": 117,
    "description": "Premium guided travel experience.",
    "ratings": 4.9,
    "hours": 6,
    "image": "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=600&q=80",
    "type": "wildlife",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 20,
    "city": "Ahmedabad",
    "price": 222,
    "description": "Premium guided travel experience.",
    "ratings": 4.7,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.NtWZ07CQhvq5Tr6UrKwigwHaEk?w=252&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "scenic",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 21,
    "city": "Paris",
    "price": 99,
    "description": "Premium guided travel experience.",
    "ratings": 4.3,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.Hdq8A05fSZxRDlRwO5oJywHaE8?w=308&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "historical",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 22,
    "city": "Tokyo",
    "price": 214,
    "description": "Premium guided travel experience.",
    "ratings": 4.4,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.Hdq8A05fSZxRDlRwO5oJywHaE8?w=308&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "historical",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 23,
    "city": "Australia",
    "price": 120,
    "description": "Premium guided travel experience.",
    "ratings": 4.5,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.ShQQnbhYvmU3g9jv5WwwoQHaE8?w=263&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "ghost",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 24,
    "city": "Rome",
    "price": 223,
    "description": "Premium guided travel experience.",
    "ratings": 4.5,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.prUkRnrQnCPc-bs4a10hWQHaEJ?w=282&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "food",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 25,
    "city": "Sydney",
    "price": 123,
    "description": "Premium guided travel experience.",
    "ratings": 5,
    "hours": 6,
    "image": "https://www.bing.com/th/id/OIP.TJaq2V9n1PE9jANoMpnplgHaEv?w=226&h=211&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2",
    "type": "Religious",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 26,
    "city": "Dubai",
    "price": 166,
    "description": "Premium guided travel experience.",
    "ratings": 4.7,
    "hours": 6,
    "image": "https://th.bing.com/th/id/OIP.iWuybF3U_U21pDpbScg4dgHaE8?w=249&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "adventure",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 27,
    "city": "London",
    "price": 98,
    "description": "Premium guided travel experience.",
    "ratings": 4.2,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.NtWZ07CQhvq5Tr6UrKwigwHaEk?w=252&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "scenic",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 28,
    "city": "Barcelona",
    "price": 188,
    "description": "Premium guided travel experience.",
    "ratings": 4.8,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.NtWZ07CQhvq5Tr6UrKwigwHaEk?w=252&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "scenic",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 29,
    "city": "Singapore",
    "price": 126,
    "description": "Premium guided travel experience.",
    "ratings": 4.2,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.Hdq8A05fSZxRDlRwO5oJywHaE8?w=308&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "historical",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 30,
    "city": "Bangkok",
    "price": 165,
    "description": "Premium guided travel experience.",
    "ratings": 4.1,
    "hours": 7,
    "image": "https://th.bing.com/th/id/OIP.QEjjFGjCo6H2znK-5POM9QHaE8?w=272&h=181&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "architecture",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 31,
    "city": "Toronto",
    "price": 97,
    "description": "Premium guided travel experience.",
    "ratings": 4,
    "hours": 6,
    "image": "https://th.bing.com/th/id/OIP.ShQQnbhYvmU3g9jv5WwwoQHaE8?w=263&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "ghost",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 32,
    "city": "Bali",
    "price": 135,
    "description": "Premium guided travel experience.",
    "ratings": 4.4,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.prUkRnrQnCPc-bs4a10hWQHaEJ?w=282&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "food",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 33,
    "city": "Zurich",
    "price": 117,
    "description": "Premium guided travel experience.",
    "ratings": 4.9,
    "hours": 4,
    "image": "https://www.bing.com/th/id/OIP.TJaq2V9n1PE9jANoMpnplgHaEv?w=226&h=211&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2",
    "type": "Religious",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 34,
    "city": "Amsterdam",
    "price": 111,
    "description": "Premium guided travel experience.",
    "ratings": 4.1,
    "hours": 7,
    "image": "https://th.bing.com/th/id/OIP.iWuybF3U_U21pDpbScg4dgHaE8?w=249&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "adventure",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 35,
    "city": "Prague",
    "price": 164,
    "description": "Premium guided travel experience.",
    "ratings": 5,
    "hours": 4,
    "image": "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=600&q=80",
    "type": "wildlife",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 36,
    "city": "Istanbul",
    "price": 220,
    "description": "Premium guided travel experience.",
    "ratings": 4.4,
    "hours": 6,
    "image": "https://th.bing.com/th/id/OIP.NtWZ07CQhvq5Tr6UrKwigwHaEk?w=252&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "scenic",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 37,
    "city": "Vienna",
    "price": 83,
    "description": "Premium guided travel experience.",
    "ratings": 4.3,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.Hdq8A05fSZxRDlRwO5oJywHaE8?w=308&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "historical",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 38,
    "city": "Seoul",
    "price": 190,
    "description": "Premium guided travel experience.",
    "ratings": 4.7,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.QEjjFGjCo6H2znK-5POM9QHaE8?w=272&h=181&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "architecture",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 39,
    "city": "Los",
    "price": 152,
    "description": "Premium guided travel experience.",
    "ratings": 4.1,
    "hours": 6,
    "image": "https://th.bing.com/th/id/OIP.ShQQnbhYvmU3g9jv5WwwoQHaE8?w=263&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "ghost",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 40,
    "city": "Canada",
    "price": 107,
    "description": "Premium guided travel experience.",
    "ratings": 4.4,
    "hours": 6,
    "image": "https://th.bing.com/th/id/OIP.prUkRnrQnCPc-bs4a10hWQHaEJ?w=282&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "food",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 41,
    "city": "Delhi",
    "price": 172,
    "description": "Premium guided travel experience.",
    "ratings": 4.9,
    "hours": 7,
    "image": "https://www.bing.com/th/id/OIP.TJaq2V9n1PE9jANoMpnplgHaEv?w=226&h=211&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2",
    "type": "Religious",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 42,
    "city": "Mumbai",
    "price": 108,
    "description": "Premium guided travel experience.",
    "ratings": 4.7,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.iWuybF3U_U21pDpbScg4dgHaE8?w=249&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "adventure",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 43,
    "city": "Jaipur",
    "price": 216,
    "description": "Premium guided travel experience.",
    "ratings": 4.7,
    "hours": 7,
    "image": "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=600&q=80",
    "type": "wildlife",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 44,
    "city": "Goa",
    "price": 155,
    "description": "Premium guided travel experience.",
    "ratings": 4.3,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.NtWZ07CQhvq5Tr6UrKwigwHaEk?w=252&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "scenic",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 45,
    "city": "Varanasi",
    "price": 194,
    "description": "Premium guided travel experience.",
    "ratings": 4.3,
    "hours": 6,
    "image": "https://th.bing.com/th/id/OIP.Hdq8A05fSZxRDlRwO5oJywHaE8?w=308&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "historical",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 46,
    "city": "Agra",
    "price": 200,
    "description": "Premium guided travel experience.",
    "ratings": 4.7,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.QEjjFGjCo6H2znK-5POM9QHaE8?w=272&h=181&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "architecture",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 47,
    "city": "Udaipur",
    "price": 85,
    "description": "Premium guided travel experience.",
    "ratings": 4.5,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.ShQQnbhYvmU3g9jv5WwwoQHaE8?w=263&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "ghost",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 48,
    "city": "Kolkata",
    "price": 208,
    "description": "Premium guided travel experience.",
    "ratings": 4.9,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.prUkRnrQnCPc-bs4a10hWQHaEJ?w=282&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "food",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 49,
    "city": "Chennai",
    "price": 143,
    "description": "Premium guided travel experience.",
    "ratings": 4.3,
    "hours": 4,
    "image": "https://www.bing.com/th/id/OIP.TJaq2V9n1PE9jANoMpnplgHaEv?w=226&h=211&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2",
    "type": "Religious",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 50,
    "city": "Hyderabad",
    "price": 207,
    "description": "Premium guided travel experience.",
    "ratings": 4.3,
    "hours": 6,
    "image": "https://th.bing.com/th/id/OIP.iWuybF3U_U21pDpbScg4dgHaE8?w=249&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "adventure",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 51,
    "city": "Bangalore",
    "price": 210,
    "description": "Premium guided travel experience.",
    "ratings": 4.9,
    "hours": 6,
    "image": "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=600&q=80",
    "type": "wildlife",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 52,
    "city": "Shimla",
    "price": 148,
    "description": "Premium guided travel experience.",
    "ratings": 4,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.NtWZ07CQhvq5Tr6UrKwigwHaEk?w=252&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "scenic",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 53,
    "city": "Manali",
    "price": 94,
    "description": "Premium guided travel experience.",
    "ratings": 4.9,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.Hdq8A05fSZxRDlRwO5oJywHaE8?w=308&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "historical",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 54,
    "city": "Rishikesh",
    "price": 106,
    "description": "Premium guided travel experience.",
    "ratings": 4.1,
    "hours": 7,
    "image": "https://th.bing.com/th/id/OIP.QEjjFGjCo6H2znK-5POM9QHaE8?w=272&h=181&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "architecture",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 55,
    "city": "Amritsar",
    "price": 86,
    "description": "Premium guided travel experience.",
    "ratings": 4.1,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.ShQQnbhYvmU3g9jv5WwwoQHaE8?w=263&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "ghost",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 56,
    "city": "Mysore",
    "price": 211,
    "description": "Premium guided travel experience.",
    "ratings": 4.7,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.prUkRnrQnCPc-bs4a10hWQHaEJ?w=282&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "food",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 57,
    "city": "Darjeeling",
    "price": 100,
    "description": "Premium guided travel experience.",
    "ratings": 4.1,
    "hours": 6,
    "image": "https://www.bing.com/th/id/OIP.TJaq2V9n1PE9jANoMpnplgHaEv?w=226&h=211&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2",
    "type": "Religious",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 58,
    "city": "Leh",
    "price": 161,
    "description": "Premium guided travel experience.",
    "ratings": 4.6,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.iWuybF3U_U21pDpbScg4dgHaE8?w=249&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "adventure",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 59,
    "city": "Pune",
    "price": 126,
    "description": "Premium guided travel experience.",
    "ratings": 4.1,
    "hours": 6,
    "image": "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=600&q=80",
    "type": "wildlife",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 60,
    "city": "Ahmedabad",
    "price": 197,
    "description": "Premium guided travel experience.",
    "ratings": 4.6,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.NtWZ07CQhvq5Tr6UrKwigwHaEk?w=252&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "scenic",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 61,
    "city": "Paris",
    "price": 183,
    "description": "Premium guided travel experience.",
    "ratings": 4.3,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.Hdq8A05fSZxRDlRwO5oJywHaE8?w=308&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "historical",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 62,
    "city": "Tokyo",
    "price": 144,
    "description": "Premium guided travel experience.",
    "ratings": 5,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.QEjjFGjCo6H2znK-5POM9QHaE8?w=272&h=181&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "architecture",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 63,
    "city": "Australia",
    "price": 141,
    "description": "Premium guided travel experience.",
    "ratings": 4.6,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.QEjjFGjCo6H2znK-5POM9QHaE8?w=272&h=181&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "architecture",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 64,
    "city": "Rome",
    "price": 112,
    "description": "Premium guided travel experience.",
    "ratings": 4.5,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.prUkRnrQnCPc-bs4a10hWQHaEJ?w=282&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "food",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 65,
    "city": "Sydney",
    "price": 139,
    "description": "Premium guided travel experience.",
    "ratings": 4.7,
    "hours": 5,
    "image": "https://www.bing.com/th/id/OIP.TJaq2V9n1PE9jANoMpnplgHaEv?w=226&h=211&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2",
    "type": "Religious",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 66,
    "city": "Dubai",
    "price": 127,
    "description": "Premium guided travel experience.",
    "ratings": 4.1,
    "hours": 7,
    "image": "https://th.bing.com/th/id/OIP.iWuybF3U_U21pDpbScg4dgHaE8?w=249&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "adventure",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 67,
    "city": "London",
    "price": 160,
    "description": "Premium guided travel experience.",
    "ratings": 4.6,
    "hours": 4,
    "image": "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=600&q=80",
    "type": "wildlife",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 68,
    "city": "Barcelona",
    "price": 200,
    "description": "Premium guided travel experience.",
    "ratings": 4.6,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.NtWZ07CQhvq5Tr6UrKwigwHaEk?w=252&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "scenic",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 69,
    "city": "Singapore",
    "price": 108,
    "description": "Premium guided travel experience.",
    "ratings": 4.2,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.Hdq8A05fSZxRDlRwO5oJywHaE8?w=308&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "historical",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 70,
    "city": "Bangkok",
    "price": 143,
    "description": "Premium guided travel experience.",
    "ratings": 4.9,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.QEjjFGjCo6H2znK-5POM9QHaE8?w=272&h=181&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "architecture",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 71,
    "city": "Toronto",
    "price": 167,
    "description": "Premium guided travel experience.",
    "ratings": 4.8,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.ShQQnbhYvmU3g9jv5WwwoQHaE8?w=263&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "ghost",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 72,
    "city": "Bali",
    "price": 138,
    "description": "Premium guided travel experience.",
    "ratings": 4.6,
    "hours": 7,
    "image": "https://th.bing.com/th/id/OIP.prUkRnrQnCPc-bs4a10hWQHaEJ?w=282&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "food",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 73,
    "city": "Zurich",
    "price": 198,
    "description": "Premium guided travel experience.",
    "ratings": 4.7,
    "hours": 4,
    "image": "https://www.bing.com/th/id/OIP.TJaq2V9n1PE9jANoMpnplgHaEv?w=226&h=211&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2",
    "type": "Religious",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 74,
    "city": "Amsterdam",
    "price": 152,
    "description": "Premium guided travel experience.",
    "ratings": 4.6,
    "hours": 6,
    "image": "https://th.bing.com/th/id/OIP.iWuybF3U_U21pDpbScg4dgHaE8?w=249&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "adventure",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 75,
    "city": "Prague",
    "price": 127,
    "description": "Premium guided travel experience.",
    "ratings": 4.1,
    "hours": 3,
    "image": "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=600&q=80",
    "type": "wildlife",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 76,
    "city": "Istanbul",
    "price": 189,
    "description": "Premium guided travel experience.",
    "ratings": 4.1,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.NtWZ07CQhvq5Tr6UrKwigwHaEk?w=252&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "scenic",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 77,
    "city": "Vienna",
    "price": 189,
    "description": "Premium guided travel experience.",
    "ratings": 4,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.Hdq8A05fSZxRDlRwO5oJywHaE8?w=308&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "historical",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 78,
    "city": "Seoul",
    "price": 188,
    "description": "Premium guided travel experience.",
    "ratings": 4.9,
    "hours": 7,
    "image": "https://th.bing.com/th/id/OIP.QEjjFGjCo6H2znK-5POM9QHaE8?w=272&h=181&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "architecture",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 79,
    "city": "Los",
    "price": 228,
    "description": "Premium guided travel experience.",
    "ratings": 4.8,
    "hours": 7,
    "image": "https://th.bing.com/th/id/OIP.ShQQnbhYvmU3g9jv5WwwoQHaE8?w=263&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "ghost",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 80,
    "city": "Canada",
    "price": 182,
    "description": "Premium guided travel experience.",
    "ratings": 4.3,
    "hours": 7,
    "image": "https://th.bing.com/th/id/OIP.prUkRnrQnCPc-bs4a10hWQHaEJ?w=282&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "food",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 81,
    "city": "Delhi",
    "price": 113,
    "description": "Premium guided travel experience.",
    "ratings": 4.3,
    "hours": 3,
    "image": "https://www.bing.com/th/id/OIP.TJaq2V9n1PE9jANoMpnplgHaEv?w=226&h=211&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2",
    "type": "Religious",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 82,
    "city": "Mumbai",
    "price": 220,
    "description": "Premium guided travel experience.",
    "ratings": 4.2,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.iWuybF3U_U21pDpbScg4dgHaE8?w=249&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "adventure",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 83,
    "city": "Jaipur",
    "price": 170,
    "description": "Premium guided travel experience.",
    "ratings": 4.6,
    "hours": 6,
    "image": "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=600&q=80",
    "type": "wildlife",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 84,
    "city": "Goa",
    "price": 168,
    "description": "Premium guided travel experience.",
    "ratings": 4.2,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.NtWZ07CQhvq5Tr6UrKwigwHaEk?w=252&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "scenic",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 85,
    "city": "Varanasi",
    "price": 111,
    "description": "Premium guided travel experience.",
    "ratings": 4.3,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.Hdq8A05fSZxRDlRwO5oJywHaE8?w=308&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "historical",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 86,
    "city": "Agra",
    "price": 178,
    "description": "Premium guided travel experience.",
    "ratings": 4.4,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.QEjjFGjCo6H2znK-5POM9QHaE8?w=272&h=181&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "architecture",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 87,
    "city": "Udaipur",
    "price": 176,
    "description": "Premium guided travel experience.",
    "ratings": 4,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.ShQQnbhYvmU3g9jv5WwwoQHaE8?w=263&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "ghost",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 88,
    "city": "Kolkata",
    "price": 228,
    "description": "Premium guided travel experience.",
    "ratings": 4.5,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.prUkRnrQnCPc-bs4a10hWQHaEJ?w=282&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "food",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 89,
    "city": "Chennai",
    "price": 92,
    "description": "Premium guided travel experience.",
    "ratings": 4.3,
    "hours": 4,
    "image": "https://www.bing.com/th/id/OIP.TJaq2V9n1PE9jANoMpnplgHaEv?w=226&h=211&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2",
    "type": "Religious",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 90,
    "city": "Hyderabad",
    "price": 202,
    "description": "Premium guided travel experience.",
    "ratings": 4.1,
    "hours": 6,
    "image": "https://th.bing.com/th/id/OIP.iWuybF3U_U21pDpbScg4dgHaE8?w=249&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "adventure",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 91,
    "city": "Bangalore",
    "price": 97,
    "description": "Premium guided travel experience.",
    "ratings": 4.6,
    "hours": 5,
    "image": "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=600&q=80",
    "type": "wildlife",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 92,
    "city": "Shimla",
    "price": 170,
    "description": "Premium guided travel experience.",
    "ratings": 4.4,
    "hours": 6,
    "image": "https://th.bing.com/th/id/OIP.NtWZ07CQhvq5Tr6UrKwigwHaEk?w=252&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "scenic",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 93,
    "city": "Manali",
    "price": 210,
    "description": "Premium guided travel experience.",
    "ratings": 4.3,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.Hdq8A05fSZxRDlRwO5oJywHaE8?w=308&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "historical",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 94,
    "city": "Rishikesh",
    "price": 193,
    "description": "Premium guided travel experience.",
    "ratings": 4.3,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.QEjjFGjCo6H2znK-5POM9QHaE8?w=272&h=181&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "architecture",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 95,
    "city": "Amritsar",
    "price": 92,
    "description": "Premium guided travel experience.",
    "ratings": 4.3,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.ShQQnbhYvmU3g9jv5WwwoQHaE8?w=263&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "ghost",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 96,
    "city": "Mysore",
    "price": 152,
    "description": "Premium guided travel experience.",
    "ratings": 4.8,
    "hours": 7,
    "image": "https://th.bing.com/th/id/OIP.prUkRnrQnCPc-bs4a10hWQHaEJ?w=282&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "food",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 97,
    "city": "Darjeeling",
    "price": 151,
    "description": "Premium guided travel experience.",
    "ratings": 4.1,
    "hours": 4,
    "image": "https://www.bing.com/th/id/OIP.TJaq2V9n1PE9jANoMpnplgHaEv?w=226&h=211&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2",
    "type": "Religious",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 98,
    "city": "Leh",
    "price": 160,
    "description": "Premium guided travel experience.",
    "ratings": 4.6,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.iWuybF3U_U21pDpbScg4dgHaE8?w=249&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "adventure",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 99,
    "city": "Pune",
    "price": 216,
    "description": "Premium guided travel experience.",
    "ratings": 4.6,
    "hours": 6,
    "image": "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=600&q=80",
    "type": "wildlife",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 100,
    "city": "Ahmedabad",
    "price": 167,
    "description": "Premium guided travel experience.",
    "ratings": 5,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.NtWZ07CQhvq5Tr6UrKwigwHaEk?w=252&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "scenic",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 101,
    "city": "Paris",
    "price": 155,
    "description": "Premium guided travel experience.",
    "ratings": 4,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.NtWZ07CQhvq5Tr6UrKwigwHaEk?w=252&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "scenic",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 102,
    "city": "Tokyo",
    "price": 131,
    "description": "Premium guided travel experience.",
    "ratings": 4.1,
    "hours": 6,
    "image": "https://th.bing.com/th/id/OIP.QEjjFGjCo6H2znK-5POM9QHaE8?w=272&h=181&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "architecture",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 103,
    "city": "Australia",
    "price": 186,
    "description": "Premium guided travel experience.",
    "ratings": 4.5,
    "hours": 7,
    "image": "https://th.bing.com/th/id/OIP.ShQQnbhYvmU3g9jv5WwwoQHaE8?w=263&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "ghost",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 104,
    "city": "Rome",
    "price": 99,
    "description": "Premium guided travel experience.",
    "ratings": 5,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.prUkRnrQnCPc-bs4a10hWQHaEJ?w=282&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "food",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 105,
    "city": "Sydney",
    "price": 86,
    "description": "Premium guided travel experience.",
    "ratings": 4.2,
    "hours": 5,
    "image": "https://www.bing.com/th/id/OIP.TJaq2V9n1PE9jANoMpnplgHaEv?w=226&h=211&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2",
    "type": "Religious",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 106,
    "city": "Dubai",
    "price": 149,
    "description": "Premium guided travel experience.",
    "ratings": 4.1,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.iWuybF3U_U21pDpbScg4dgHaE8?w=249&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "adventure",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 107,
    "city": "London",
    "price": 166,
    "description": "Premium guided travel experience.",
    "ratings": 4.7,
    "hours": 4,
    "image": "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=600&q=80",
    "type": "wildlife",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 108,
    "city": "Barcelona",
    "price": 99,
    "description": "Premium guided travel experience.",
    "ratings": 4.6,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.NtWZ07CQhvq5Tr6UrKwigwHaEk?w=252&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "scenic",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 109,
    "city": "Singapore",
    "price": 120,
    "description": "Premium guided travel experience.",
    "ratings": 4.3,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.Hdq8A05fSZxRDlRwO5oJywHaE8?w=308&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "historical",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 110,
    "city": "Bangkok",
    "price": 202,
    "description": "Premium guided travel experience.",
    "ratings": 4.7,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.QEjjFGjCo6H2znK-5POM9QHaE8?w=272&h=181&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "architecture",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 111,
    "city": "Toronto",
    "price": 186,
    "description": "Premium guided travel experience.",
    "ratings": 4.6,
    "hours": 6,
    "image": "https://th.bing.com/th/id/OIP.ShQQnbhYvmU3g9jv5WwwoQHaE8?w=263&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "ghost",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 112,
    "city": "Bali",
    "price": 196,
    "description": "Premium guided travel experience.",
    "ratings": 4.9,
    "hours": 7,
    "image": "https://th.bing.com/th/id/OIP.prUkRnrQnCPc-bs4a10hWQHaEJ?w=282&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "food",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 113,
    "city": "Zurich",
    "price": 105,
    "description": "Premium guided travel experience.",
    "ratings": 4.8,
    "hours": 3,
    "image": "https://www.bing.com/th/id/OIP.TJaq2V9n1PE9jANoMpnplgHaEv?w=226&h=211&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2",
    "type": "Religious",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 114,
    "city": "Amsterdam",
    "price": 148,
    "description": "Premium guided travel experience.",
    "ratings": 4.6,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.iWuybF3U_U21pDpbScg4dgHaE8?w=249&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "adventure",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 115,
    "city": "Prague",
    "price": 205,
    "description": "Premium guided travel experience.",
    "ratings": 4.2,
    "hours": 5,
    "image": "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=600&q=80",
    "type": "wildlife",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 116,
    "city": "Istanbul",
    "price": 199,
    "description": "Premium guided travel experience.",
    "ratings": 4.2,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.NtWZ07CQhvq5Tr6UrKwigwHaEk?w=252&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "scenic",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 117,
    "city": "Vienna",
    "price": 129,
    "description": "Premium guided travel experience.",
    "ratings": 4.6,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.Hdq8A05fSZxRDlRwO5oJywHaE8?w=308&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "historical",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 118,
    "city": "Seoul",
    "price": 197,
    "description": "Premium guided travel experience.",
    "ratings": 4.1,
    "hours": 7,
    "image": "https://th.bing.com/th/id/OIP.QEjjFGjCo6H2znK-5POM9QHaE8?w=272&h=181&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "architecture",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 119,
    "city": "Los",
    "price": 138,
    "description": "Premium guided travel experience.",
    "ratings": 4.6,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.ShQQnbhYvmU3g9jv5WwwoQHaE8?w=263&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "ghost",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 120,
    "city": "Canada",
    "price": 106,
    "description": "Premium guided travel experience.",
    "ratings": 4,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.prUkRnrQnCPc-bs4a10hWQHaEJ?w=282&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "food",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 121,
    "city": "Delhi",
    "price": 133,
    "description": "Premium guided travel experience.",
    "ratings": 4.8,
    "hours": 5,
    "image": "https://www.bing.com/th/id/OIP.TJaq2V9n1PE9jANoMpnplgHaEv?w=226&h=211&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2",
    "type": "Religious",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 122,
    "city": "Mumbai",
    "price": 226,
    "description": "Premium guided travel experience.",
    "ratings": 4.1,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.iWuybF3U_U21pDpbScg4dgHaE8?w=249&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "adventure",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 123,
    "city": "Jaipur",
    "price": 194,
    "description": "Premium guided travel experience.",
    "ratings": 4.5,
    "hours": 4,
    "image": "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=600&q=80",
    "type": "wildlife",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 124,
    "city": "Goa",
    "price": 102,
    "description": "Premium guided travel experience.",
    "ratings": 4,
    "hours": 6,
    "image": "https://th.bing.com/th/id/OIP.NtWZ07CQhvq5Tr6UrKwigwHaEk?w=252&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "scenic",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 125,
    "city": "Varanasi",
    "price": 151,
    "description": "Premium guided travel experience.",
    "ratings": 4.3,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.Hdq8A05fSZxRDlRwO5oJywHaE8?w=308&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "historical",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 126,
    "city": "Agra",
    "price": 173,
    "description": "Premium guided travel experience.",
    "ratings": 4.3,
    "hours": 6,
    "image": "https://th.bing.com/th/id/OIP.QEjjFGjCo6H2znK-5POM9QHaE8?w=272&h=181&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "architecture",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 127,
    "city": "Udaipur",
    "price": 170,
    "description": "Premium guided travel experience.",
    "ratings": 4.6,
    "hours": 6,
    "image": "https://th.bing.com/th/id/OIP.ShQQnbhYvmU3g9jv5WwwoQHaE8?w=263&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "ghost",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 128,
    "city": "Kolkata",
    "price": 144,
    "description": "Premium guided travel experience.",
    "ratings": 4.4,
    "hours": 6,
    "image": "https://th.bing.com/th/id/OIP.prUkRnrQnCPc-bs4a10hWQHaEJ?w=282&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "food",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 129,
    "city": "Chennai",
    "price": 124,
    "description": "Premium guided travel experience.",
    "ratings": 4.8,
    "hours": 5,
    "image": "https://www.bing.com/th/id/OIP.TJaq2V9n1PE9jANoMpnplgHaEv?w=226&h=211&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2",
    "type": "Religious",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 130,
    "city": "Hyderabad",
    "price": 190,
    "description": "Premium guided travel experience.",
    "ratings": 4.1,
    "hours": 7,
    "image": "https://th.bing.com/th/id/OIP.iWuybF3U_U21pDpbScg4dgHaE8?w=249&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "adventure",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 131,
    "city": "Bangalore",
    "price": 95,
    "description": "Premium guided travel experience.",
    "ratings": 4,
    "hours": 4,
    "image": "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=600&q=80",
    "type": "wildlife",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 132,
    "city": "Shimla",
    "price": 103,
    "description": "Premium guided travel experience.",
    "ratings": 4.5,
    "hours": 7,
    "image": "https://th.bing.com/th/id/OIP.NtWZ07CQhvq5Tr6UrKwigwHaEk?w=252&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "scenic",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 133,
    "city": "Manali",
    "price": 158,
    "description": "Premium guided travel experience.",
    "ratings": 4.4,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.Hdq8A05fSZxRDlRwO5oJywHaE8?w=308&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "historical",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 134,
    "city": "Rishikesh",
    "price": 200,
    "description": "Premium guided travel experience.",
    "ratings": 4.5,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.QEjjFGjCo6H2znK-5POM9QHaE8?w=272&h=181&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "architecture",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 135,
    "city": "Amritsar",
    "price": 171,
    "description": "Premium guided travel experience.",
    "ratings": 4.3,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.ShQQnbhYvmU3g9jv5WwwoQHaE8?w=263&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "ghost",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 136,
    "city": "Mysore",
    "price": 209,
    "description": "Premium guided travel experience.",
    "ratings": 4.5,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.prUkRnrQnCPc-bs4a10hWQHaEJ?w=282&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "food",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 137,
    "city": "Darjeeling",
    "price": 198,
    "description": "Premium guided travel experience.",
    "ratings": 5,
    "hours": 5,
    "image": "https://www.bing.com/th/id/OIP.TJaq2V9n1PE9jANoMpnplgHaEv?w=226&h=211&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2",
    "type": "Religious",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 138,
    "city": "Leh",
    "price": 118,
    "description": "Premium guided travel experience.",
    "ratings": 4.8,
    "hours": 7,
    "image": "https://th.bing.com/th/id/OIP.iWuybF3U_U21pDpbScg4dgHaE8?w=249&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "adventure",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 139,
    "city": "Pune",
    "price": 227,
    "description": "Premium guided travel experience.",
    "ratings": 4.7,
    "hours": 5,
    "image": "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=600&q=80",
    "type": "wildlife",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 140,
    "city": "Ahmedabad",
    "price": 117,
    "description": "Premium guided travel experience.",
    "ratings": 5,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.NtWZ07CQhvq5Tr6UrKwigwHaEk?w=252&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "scenic",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 141,
    "city": "Paris",
    "price": 222,
    "description": "Premium guided travel experience.",
    "ratings": 4,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.Hdq8A05fSZxRDlRwO5oJywHaE8?w=308&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "historical",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 142,
    "city": "Tokyo",
    "price": 176,
    "description": "Premium guided travel experience.",
    "ratings": 4.8,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.QEjjFGjCo6H2znK-5POM9QHaE8?w=272&h=181&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "architecture",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 143,
    "city": "Australia",
    "price": 187,
    "description": "Premium guided travel experience.",
    "ratings": 4,
    "hours": 7,
    "image": "https://th.bing.com/th/id/OIP.ShQQnbhYvmU3g9jv5WwwoQHaE8?w=263&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "ghost",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 144,
    "city": "Rome",
    "price": 165,
    "description": "Premium guided travel experience.",
    "ratings": 4.8,
    "hours": 6,
    "image": "https://th.bing.com/th/id/OIP.prUkRnrQnCPc-bs4a10hWQHaEJ?w=282&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "food",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 145,
    "city": "Sydney",
    "price": 123,
    "description": "Premium guided travel experience.",
    "ratings": 4.7,
    "hours": 7,
    "image": "https://www.bing.com/th/id/OIP.TJaq2V9n1PE9jANoMpnplgHaEv?w=226&h=211&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2",
    "type": "Religious",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 146,
    "city": "Dubai",
    "price": 218,
    "description": "Premium guided travel experience.",
    "ratings": 4.5,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.iWuybF3U_U21pDpbScg4dgHaE8?w=249&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "adventure",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 147,
    "city": "London",
    "price": 210,
    "description": "Premium guided travel experience.",
    "ratings": 4.3,
    "hours": 4,
    "image": "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=600&q=80",
    "type": "wildlife",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 148,
    "city": "Barcelona",
    "price": 201,
    "description": "Premium guided travel experience.",
    "ratings": 4.8,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.NtWZ07CQhvq5Tr6UrKwigwHaEk?w=252&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "scenic",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 149,
    "city": "Singapore",
    "price": 152,
    "description": "Premium guided travel experience.",
    "ratings": 4.1,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.Hdq8A05fSZxRDlRwO5oJywHaE8?w=308&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "historical",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 150,
    "city": "Bangkok",
    "price": 105,
    "description": "Premium guided travel experience.",
    "ratings": 4.4,
    "hours": 7,
    "image": "https://th.bing.com/th/id/OIP.QEjjFGjCo6H2znK-5POM9QHaE8?w=272&h=181&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "architecture",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 151,
    "city": "Toronto",
    "price": 202,
    "description": "Premium guided travel experience.",
    "ratings": 5,
    "hours": 6,
    "image": "https://th.bing.com/th/id/OIP.ShQQnbhYvmU3g9jv5WwwoQHaE8?w=263&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "ghost",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 152,
    "city": "Bali",
    "price": 138,
    "description": "Premium guided travel experience.",
    "ratings": 5,
    "hours": 6,
    "image": "https://th.bing.com/th/id/OIP.prUkRnrQnCPc-bs4a10hWQHaEJ?w=282&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "food",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 153,
    "city": "Zurich",
    "price": 145,
    "description": "Premium guided travel experience.",
    "ratings": 4.3,
    "hours": 4,
    "image": "https://www.bing.com/th/id/OIP.TJaq2V9n1PE9jANoMpnplgHaEv?w=226&h=211&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2",
    "type": "Religious",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 154,
    "city": "Amsterdam",
    "price": 154,
    "description": "Premium guided travel experience.",
    "ratings": 4.9,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.iWuybF3U_U21pDpbScg4dgHaE8?w=249&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "adventure",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 155,
    "city": "Prague",
    "price": 144,
    "description": "Premium guided travel experience.",
    "ratings": 4.3,
    "hours": 6,
    "image": "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=600&q=80",
    "type": "wildlife",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 156,
    "city": "Istanbul",
    "price": 145,
    "description": "Premium guided travel experience.",
    "ratings": 4.6,
    "hours": 6,
    "image": "https://th.bing.com/th/id/OIP.NtWZ07CQhvq5Tr6UrKwigwHaEk?w=252&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "scenic",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 157,
    "city": "Vienna",
    "price": 122,
    "description": "Premium guided travel experience.",
    "ratings": 4.5,
    "hours": 6,
    "image": "https://th.bing.com/th/id/OIP.Hdq8A05fSZxRDlRwO5oJywHaE8?w=308&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "historical",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 158,
    "city": "Seoul",
    "price": 118,
    "description": "Premium guided travel experience.",
    "ratings": 4.2,
    "hours": 6,
    "image": "https://th.bing.com/th/id/OIP.QEjjFGjCo6H2znK-5POM9QHaE8?w=272&h=181&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "architecture",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 159,
    "city": "Los",
    "price": 211,
    "description": "Premium guided travel experience.",
    "ratings": 4,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.ShQQnbhYvmU3g9jv5WwwoQHaE8?w=263&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "ghost",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 160,
    "city": "Canada",
    "price": 210,
    "description": "Premium guided travel experience.",
    "ratings": 4.1,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.prUkRnrQnCPc-bs4a10hWQHaEJ?w=282&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "food",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 161,
    "city": "Delhi",
    "price": 225,
    "description": "Premium guided travel experience.",
    "ratings": 4.5,
    "hours": 7,
    "image": "https://www.bing.com/th/id/OIP.TJaq2V9n1PE9jANoMpnplgHaEv?w=226&h=211&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2",
    "type": "Religious",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 162,
    "city": "Mumbai",
    "price": 144,
    "description": "Premium guided travel experience.",
    "ratings": 4.5,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.iWuybF3U_U21pDpbScg4dgHaE8?w=249&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "adventure",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 163,
    "city": "Jaipur",
    "price": 82,
    "description": "Premium guided travel experience.",
    "ratings": 4.4,
    "hours": 4,
    "image": "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=600&q=80",
    "type": "wildlife",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 164,
    "city": "Goa",
    "price": 184,
    "description": "Premium guided travel experience.",
    "ratings": 4.8,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.NtWZ07CQhvq5Tr6UrKwigwHaEk?w=252&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "scenic",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 165,
    "city": "Varanasi",
    "price": 126,
    "description": "Premium guided travel experience.",
    "ratings": 4.5,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.Hdq8A05fSZxRDlRwO5oJywHaE8?w=308&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "historical",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 166,
    "city": "Agra",
    "price": 163,
    "description": "Premium guided travel experience.",
    "ratings": 4.8,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.QEjjFGjCo6H2znK-5POM9QHaE8?w=272&h=181&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "architecture",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 167,
    "city": "Udaipur",
    "price": 160,
    "description": "Premium guided travel experience.",
    "ratings": 4.7,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.ShQQnbhYvmU3g9jv5WwwoQHaE8?w=263&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "ghost",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 168,
    "city": "Kolkata",
    "price": 82,
    "description": "Premium guided travel experience.",
    "ratings": 4.7,
    "hours": 6,
    "image": "https://th.bing.com/th/id/OIP.prUkRnrQnCPc-bs4a10hWQHaEJ?w=282&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "food",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 169,
    "city": "Chennai",
    "price": 96,
    "description": "Premium guided travel experience.",
    "ratings": 4.5,
    "hours": 7,
    "image": "https://www.bing.com/th/id/OIP.TJaq2V9n1PE9jANoMpnplgHaEv?w=226&h=211&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2",
    "type": "Religious",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 170,
    "city": "Hyderabad",
    "price": 91,
    "description": "Premium guided travel experience.",
    "ratings": 4,
    "hours": 6,
    "image": "https://th.bing.com/th/id/OIP.iWuybF3U_U21pDpbScg4dgHaE8?w=249&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "adventure",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 171,
    "city": "Bangalore",
    "price": 213,
    "description": "Premium guided travel experience.",
    "ratings": 4.5,
    "hours": 6,
    "image": "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=600&q=80",
    "type": "wildlife",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 172,
    "city": "Shimla",
    "price": 183,
    "description": "Premium guided travel experience.",
    "ratings": 4.7,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.NtWZ07CQhvq5Tr6UrKwigwHaEk?w=252&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "scenic",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 173,
    "city": "Manali",
    "price": 179,
    "description": "Premium guided travel experience.",
    "ratings": 4.8,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.Hdq8A05fSZxRDlRwO5oJywHaE8?w=308&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "historical",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 174,
    "city": "Rishikesh",
    "price": 141,
    "description": "Premium guided travel experience.",
    "ratings": 4.3,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.QEjjFGjCo6H2znK-5POM9QHaE8?w=272&h=181&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "architecture",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 175,
    "city": "Amritsar",
    "price": 209,
    "description": "Premium guided travel experience.",
    "ratings": 4.4,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.ShQQnbhYvmU3g9jv5WwwoQHaE8?w=263&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "ghost",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 176,
    "city": "Mysore",
    "price": 162,
    "description": "Premium guided travel experience.",
    "ratings": 5,
    "hours": 7,
    "image": "https://th.bing.com/th/id/OIP.prUkRnrQnCPc-bs4a10hWQHaEJ?w=282&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "food",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 177,
    "city": "Darjeeling",
    "price": 202,
    "description": "Premium guided travel experience.",
    "ratings": 4.8,
    "hours": 3,
    "image": "https://www.bing.com/th/id/OIP.TJaq2V9n1PE9jANoMpnplgHaEv?w=226&h=211&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2",
    "type": "Religious",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 178,
    "city": "Leh",
    "price": 180,
    "description": "Premium guided travel experience.",
    "ratings": 4.1,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.iWuybF3U_U21pDpbScg4dgHaE8?w=249&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "adventure",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 179,
    "city": "Pune",
    "price": 94,
    "description": "Premium guided travel experience.",
    "ratings": 4.6,
    "hours": 5,
    "image": "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=600&q=80",
    "type": "wildlife",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 180,
    "city": "Ahmedabad",
    "price": 138,
    "description": "Premium guided travel experience.",
    "ratings": 4.2,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.NtWZ07CQhvq5Tr6UrKwigwHaEk?w=252&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "scenic",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 181,
    "city": "Paris",
    "price": 146,
    "description": "Premium guided travel experience.",
    "ratings": 4.4,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.Hdq8A05fSZxRDlRwO5oJywHaE8?w=308&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "historical",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 182,
    "city": "Tokyo",
    "price": 149,
    "description": "Premium guided travel experience.",
    "ratings": 4.5,
    "hours": 5,
    "image": "https://th.bing.com/th/id/OIP.QEjjFGjCo6H2znK-5POM9QHaE8?w=272&h=181&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "architecture",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 183,
    "city": "Australia",
    "price": 191,
    "description": "Premium guided travel experience.",
    "ratings": 4.2,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.ShQQnbhYvmU3g9jv5WwwoQHaE8?w=263&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "ghost",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 184,
    "city": "Rome",
    "price": 186,
    "description": "Premium guided travel experience.",
    "ratings": 4.3,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.prUkRnrQnCPc-bs4a10hWQHaEJ?w=282&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "food",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 185,
    "city": "Sydney",
    "price": 166,
    "description": "Premium guided travel experience.",
    "ratings": 4.2,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.prUkRnrQnCPc-bs4a10hWQHaEJ?w=282&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "food",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 186,
    "city": "Dubai",
    "price": 84,
    "description": "Premium guided travel experience.",
    "ratings": 4.1,
    "hours": 6,
    "image": "https://th.bing.com/th/id/OIP.iWuybF3U_U21pDpbScg4dgHaE8?w=249&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "adventure",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 187,
    "city": "London",
    "price": 165,
    "description": "Premium guided travel experience.",
    "ratings": 4.3,
    "hours": 7,
    "image": "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=600&q=80",
    "type": "wildlife",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 188,
    "city": "Barcelona",
    "price": 162,
    "description": "Premium guided travel experience.",
    "ratings": 5,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.NtWZ07CQhvq5Tr6UrKwigwHaEk?w=252&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "scenic",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 189,
    "city": "Singapore",
    "price": 209,
    "description": "Premium guided travel experience.",
    "ratings": 4.3,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.Hdq8A05fSZxRDlRwO5oJywHaE8?w=308&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "historical",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 190,
    "city": "Bangkok",
    "price": 194,
    "description": "Premium guided travel experience.",
    "ratings": 4.6,
    "hours": 7,
    "image": "https://th.bing.com/th/id/OIP.QEjjFGjCo6H2znK-5POM9QHaE8?w=272&h=181&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "architecture",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 191,
    "city": "Toronto",
    "price": 92,
    "description": "Premium guided travel experience.",
    "ratings": 4.2,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.ShQQnbhYvmU3g9jv5WwwoQHaE8?w=263&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "ghost",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 192,
    "city": "Bali",
    "price": 140,
    "description": "Premium guided travel experience.",
    "ratings": 4.4,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.prUkRnrQnCPc-bs4a10hWQHaEJ?w=282&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "food",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 193,
    "city": "Zurich",
    "price": 178,
    "description": "Premium guided travel experience.",
    "ratings": 4.3,
    "hours": 7,
    "image": "https://www.bing.com/th/id/OIP.TJaq2V9n1PE9jANoMpnplgHaEv?w=226&h=211&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2",
    "type": "Religious",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 194,
    "city": "Amsterdam",
    "price": 184,
    "description": "Premium guided travel experience.",
    "ratings": 4.9,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.iWuybF3U_U21pDpbScg4dgHaE8?w=249&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "adventure",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 195,
    "city": "Prague",
    "price": 133,
    "description": "Premium guided travel experience.",
    "ratings": 4.1,
    "hours": 5,
    "image": "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=600&q=80",
    "type": "wildlife",
    "starting_time": "12",
    "end_time": "16"
  },
  {
    "id": 196,
    "city": "Istanbul",
    "price": 126,
    "description": "Premium guided travel experience.",
    "ratings": 4.7,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.NtWZ07CQhvq5Tr6UrKwigwHaEk?w=252&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "scenic",
    "starting_time": "8",
    "end_time": "12"
  },
  {
    "id": 197,
    "city": "Vienna",
    "price": 155,
    "description": "Premium guided travel experience.",
    "ratings": 4.5,
    "hours": 7,
    "image": "https://th.bing.com/th/id/OIP.Hdq8A05fSZxRDlRwO5oJywHaE8?w=308&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "historical",
    "starting_time": "9",
    "end_time": "13"
  },
  {
    "id": 198,
    "city": "Seoul",
    "price": 176,
    "description": "Premium guided travel experience.",
    "ratings": 4.6,
    "hours": 3,
    "image": "https://th.bing.com/th/id/OIP.QEjjFGjCo6H2znK-5POM9QHaE8?w=272&h=181&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "architecture",
    "starting_time": "10",
    "end_time": "14"
  },
  {
    "id": 199,
    "city": "Los",
    "price": 220,
    "description": "Premium guided travel experience.",
    "ratings": 4.8,
    "hours": 4,
    "image": "https://th.bing.com/th/id/OIP.ShQQnbhYvmU3g9jv5WwwoQHaE8?w=263&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "ghost",
    "starting_time": "11",
    "end_time": "15"
  },
  {
    "id": 200,
    "city": "Canada",
    "price": 210,
    "description": "Premium guided travel experience.",
    "ratings": 4.2,
    "hours": 6,
    "image": "https://th.bing.com/th/id/OIP.prUkRnrQnCPc-bs4a10hWQHaEJ?w=282&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
    "type": "food",
    "starting_time": "12",
    "end_time": "16"
  }
]

export default tourdata;